import { FC } from "react"
import { EMPTY_DATA_PLACEHOLDER } from "../../../utils/constants"
import { StyledAddress } from "../Shop/StyledShop"

const Address: FC<{
  handleClick: () => void
  address?: string
}> = ({ address, handleClick }) => {
  return (
    <StyledAddress onClick={handleClick}>
      {address || EMPTY_DATA_PLACEHOLDER}
    </StyledAddress>
  )
}

export { Address }
